import { ReclaimProfileSchema } from "@redotech/redo-dispute-settings-common/reclaim-profile";
import * as z from "zod";

// Save the reclaim profile as a unit (mirrors updateDisputeAlertAutomation), written to
// settings.disputes.reclaimProfile. Cleared fields arrive null → coalesce to the default.
export const updateReclaimProfile = {
  name: "updateReclaimProfile" as const,
  input: z.object({ profile: ReclaimProfileSchema }),
  output: z.object({ success: z.boolean() }),
};
